module.exports = __webpack_public_path__ + "static/media/lemon-slice-2.33f4e88c.png";